import { useEffect, useState, useRef } from "react";
import Image from "next/image";
import dynamic from "next/dynamic";
import Link from "next/link";
import { useRouter } from "next/router";
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Tooltip,
  OverlayTrigger,
  Modal,
} from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment-timezone";
import { useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { formatPhoneNumber } from "react-phone-number-input";
import { maskNumber, maskEmail } from "@/helper/common";
import { toast } from "react-toastify";
import { authServices } from "@/services/authServices";
import { customerServices } from "@/services/customerServices";
import { setUserData, setSession } from "@/redux/features/userSlice";
import { healerServices } from "@/services/healerServices";
import Layout from "@/components/layout";
import styles from "@/styles/HealerDetails.module.css";
import styless from "@/styles/PageLoader.module.css";
import Head from "next/head";

const OwlCarousel = dynamic(() => import("react-owl-carousel"), {
  ssr: false,
});

const HealerDetails = (props) => {
  const { session } = useSelector((state) => state.user);
  const [sliderInfo, setSliderInfo] = useState({});
  const [healerCourses, setHealerCourses] = useState([]);
  const [response, setResponse] = useState({});
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [data, setData] = useState(props.healerDetailData.data ?? {});
  const [healerDetailResponse, setHealerDetailResponse] = useState(
    props.healerDetailData ?? {}
  );
  const { router, query, push } = useRouter();
  const query_id = query.slug.split("-");
  const query_length = query_id.length - 1;
  const [showReviewMore, setShowReviewMore] = useState(false);
  const [activeTab, setActiveTab] = useState("experience");
  const [isActive, setIsActive] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [newHealerAvailability, setNewhealerAvailability] = useState([]);
  const [healerDetailMeta, setHealerDetailMeta] = useState(
    props?.healerDetailMeta ?? {}
  );
  // const [showArrMore, setShowArrMore] = useState(
  //   [...Array(100).keys()].map((i) => ({ index: i, value: false }))
  // );
  // const [showArrayMore, setShowArrayMore] = useState(
  //   [...Array(100).keys()].map((i) => ({ index: i, value: false }))
  // );
  const [listIndex, setListIndex] = useState(1);
  const [reviewData, setReviewData] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [apiLoader, setApiLoader] = useState(true);
  const [reviewsIndex, setReviewIndex] = useState();
  const [reviewsIndexNumber, setReviewIndexNumber] = useState();
  const [imageShow, setImageShow] = useState(false);
  const [imageId, setImageId] = useState("");

  const previewImage = data?.healer?.healer_image.filter(
    (file) => file.id == imageId
  );
  const [showSideButton, setShowSideButton] = useState(false);
  const firstSectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!firstSectionRef.current) return;

      const sectionTop = firstSectionRef.current.getBoundingClientRect().bottom;

      setShowSideButton(sectionTop < 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const formatDate = (dateString) => {
    const options = { day: "numeric", month: "long", year: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString(undefined, options);
  };

  const viewAllReview = () => {
    if (reviewData.length != 0) {
      setIsActive(true);
    } else {
      toast.warn("No Reviews", {
        autoClose: 5000,
      });
    }
  };
  const removeAllReview = () => {
    setIsActive(false);
  };

  useEffect(() => {
    if (Object.keys(healerDetailResponse).length == 0) {
      push("/404");
      setIsDataFetched(true);
    } else {
      setApiLoader(false);
      setNewhealerAvailability(
        Object.values(healerDetailResponse.data.healerAvailability).map(
          (item, index) => item
        )
      );
    }
    //setReviewIndex(res.data.healer.review.map(i=>i.id));
    //setReviewData(res.data.healer.review);
  }, []);

  const fetchSliderData = async () => {
    const response = await healerServices.getBlogs({
      id: data?.healer?.id,
      page: 1,
    });
    if (response.status != false) {
      setResponse(response);
      setSliderInfo(response.data);
    }
  };

  const fetchHealerPerticularCourses = async () => {
    const response = await healerServices.getPerticularHealerCourses({
      id: data?.healer?.id,
    });
    if (response.status != false) {
      setHealerCourses(response.data);
    }
  };

  const fetchHealerAllReviews = async (scroll = null) => {
    let index;
    if (scroll) {
      index = listIndex + 1;
    } else {
      setReviewData([]);
      index = 1;
    }

    //api pagination index for infinite scrolling
    setListIndex(index);
    const res = await healerServices.getHealerAllReviews({
      id: data?.healer?.id,
      page: index,
    });

    if (res.status) {
      setShowMore(true);
      if (res.data.data.length > 0) {
        setReviewData((prevReviews) => [...prevReviews, ...res.data.data]);
        setHasMore(true);
      } else {
        setHasMore(false);
      }
    } else {
      toast.error(res.message, {
        autoClose: 5000,
      });
      setHasMore(false);
    }
  };

  let snum = 0,
    sno = 0;
  useEffect(() => {
    if (data?.healer?.id) {
      fetchSliderData();
      fetchHealerAllReviews();
      fetchHealerPerticularCourses();
    }
  }, [data?.healer?.id]);

  const OwlCarousel = dynamic(() => import("react-owl-carousel"), {
    ssr: false,
  });

  function tConvert(time) {
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      time = time.slice(1);
      time[5] = +time[0] < 12 ? " AM" : " PM";
      time[0] = +time[0] % 12 || 12;
    }
    return time.join("");
  }

  return (
    <>
      <Head>
        <title>{data?.healer?.detail?.meta_title}</title>
        <meta name="title" content={data?.healer?.detail?.meta_title}></meta>
        <meta
          name="description"
          content={data?.healer?.detail?.meta_description}
        ></meta>
        <meta
          name="keywords"
          content={healerDetailMeta?.meta?.meta_keywords}
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:title"
          content={data?.healer?.detail?.meta_title}
        ></meta>
        <meta
          property="og:image"
          content={healerDetailMeta?.meta?.og_image}
        ></meta>
        <link
          rel="canonical"
          href={`https://www.zenkify.com/healers/${query.slug}/detail`}
        ></link>
      </Head>

      {apiLoader ? (
        <div className={styless.overlay}>
          <div className={styless.loader}>
            <Image
              width={151}
              height={159}
              src="/images/logo.svg"
              alt="Zenkify Logo"
            />
          </div>
        </div>
      ) : (
        <>
          {Object?.keys(data)?.length ? (
            <>
              <Link
                id="floatingBook"
                className="floating-book"
                aria-label="Book a FREE call now"
                href="/healers"
                style={{ opacity: showSideButton ? 1 : 0 }}
              >
                Book a FREE call now
              </Link>

              <section
                className={styles["healer-details-section"]}
                ref={firstSectionRef}
              >
                <Container className={styles["container"]}>
                  <Row>
                    <Col md={12} className="pb-5">
                      <div className={styles["healer-doctor-card"]}>
                        <Row>
                          <Col md={3} sm={4}>
                            <div className={styles["image-healer"]}>
                              <Image
                                width={391}
                                height={361}
                                src={
                                  data?.healer?.image == null
                                    ? "/images/dummy-user.svg"
                                    : data?.healer?.image
                                }
                                alt={
                                  data?.healer?.first_name +
                                    " " +
                                    data?.healer?.last_name ?? "doctor"
                                }
                              />
                            </div>
                          </Col>
                          <Col lg={6} md={5} sm={8}>
                            <div
                              className={
                                styles["healer-content-body"] +
                                " " +
                                "border-end"
                              }
                            >
                              <h1 className={styles["healername"]}>
                                {data?.healer?.first_name +
                                  " " +
                                  data?.healer?.last_name ??
                                  "Not Specified"}{" "}
                                <i className="ri-checkbox-circle-fill check-icon"></i>
                              </h1>
                              <h6 className={styles["healertext"]}>
                                {data?.healer?.detail?.profile_tag ??
                                  "Not Specified"}
                              </h6>
                              <div
                                className={styles["feedback"] + " " + "mb-3"}
                              >
                                <span>
                                  {[...Array(5).keys()].map((i, j) => (
                                    <>
                                      <i
                                        key={j}
                                        className={`ri-star-fill ${
                                          i + 1 <= data?.rating
                                            ? "star-fill"
                                            : ""
                                        }`}
                                      ></i>
                                    </>
                                  ))}
                                </span>
                                <p>
                                  {data?.healer?.review?.length ?? 0} Feedback
                                </p>
                              </div>
                              <ul className={styles["list-details"]}>
                                {/* <li>
                                  <i className="ri-phone-line"></i>{" "}
                                  {session?.id ? (
                                    data?.healer?.mobile_number ? (
                                      <Link
                                        href={
                                          `tel:${
                                            data?.healer?.country_code +
                                            data?.healer?.mobile_number
                                          }` ?? "Not Specified"
                                        }
                                      >
                                        {data?.healer?.country_code +
                                          " " +
                                          formatPhoneNumber(
                                            data?.healer?.country_code +
                                              data?.healer?.mobile_number
                                          ) ?? "Not Specified"}
                                      </Link>
                                    ) : (
                                      "Not Specified"
                                    )
                                  ) : (
                                    <Link
                                      href="/auth/customer/social/signin"
                                      title="Sign In To View Mobile Number"
                                    >
                                      {data?.healer?.mobile_number
                                        ? maskNumber(
                                            data?.healer?.mobile_number
                                          )
                                        : "Not Specified"}
                                    </Link>
                                  )}
                                </li>
                                <li>
                                  <i className="ri-mail-line"></i>{" "}
                                  {session?.id ? (
                                    <Link
                                      href={`mailto:${
                                        data?.healer?.email ?? "Not Specified"
                                      }`}
                                    >
                                      {data?.healer?.email ?? "Not Specified"}
                                    </Link>
                                  ) : (
                                    <Link
                                      href="/auth/customer/social/signin"
                                      title="Sign In To View Email Address"
                                    >
                                      {data?.healer?.email
                                        ? maskEmail(data?.healer?.email)
                                        : "Not Specified"}
                                    </Link>
                                  )}
                                </li> */}
                                <li>
                                  <i className="ri-calendar-line"></i>{" "}
                                  {data?.healer?.detail?.experience
                                    ? data?.healer?.detail?.experience > 1
                                      ? data?.healer?.detail?.experience +
                                        " Years"
                                      : data?.healer?.detail?.experience +
                                        " Year"
                                    : "0 Year"}{" "}
                                  Experience
                                </li>
                                {data?.healer?.booking_types.length ? (
                                  <li>
                                    <i className="ri-user-line"></i>
                                    {data?.healer?.booking_types?.map(
                                      (item, index) =>
                                        item?.booking_type?.name === "Both"
                                          ? "In-person  &  Online Sessions"
                                          : item?.booking_type?.name ??
                                            "Not Specified"
                                    )}
                                  </li>
                                ) : (
                                  ""
                                )}
                                {data?.free_call == 1 ? (
                                  <li>
                                    <i className="ri-customer-service-line"></i>{" "}
                                    Free & Paid Call Available
                                  </li>
                                ) : (
                                  <li>
                                    <i className="ri-customer-service-line"></i>{" "}
                                    Paid Call Available
                                  </li>
                                )}
                              </ul>
                              <div
                                className={
                                  styles["btn-group"] +
                                  " " +
                                  styles["btn-healing"]
                                }
                              >
                                {data?.healer?.modalities?.map(
                                  (item, index) => {
                                    return (
                                      <Link
                                        href="#"
                                        onClick={(e) => e.preventDefault()}
                                        className="btn"
                                        key={index}
                                      >
                                        {item?.modality?.name ??
                                          "Not Specified"}
                                      </Link>
                                    );
                                  }
                                )}
                              </div>
                            </div>
                          </Col>
                          <Col lg={3} md={4} className="ps-md-3">
                            <div
                              className={
                                styles["healer-content-body"] +
                                " " +
                                styles["healer-info"]
                              }
                            >
                              <ul className={styles["list-details"]}>
                                <li>
                                  <i className="ri-map-pin-line"></i>{" "}
                                  {data?.healer?.state?.name &&
                                  data?.healer?.country?.name
                                    ? `${data?.healer?.state?.name}, ${data?.healer?.country?.name}`
                                    : "Not Specified"}{" "}
                                </li>
                                <li>
                                  <i className="ri-calendar-line"></i>
                                  <div className={styles["calendar-time"]}>
                                    {newHealerAvailability != 0
                                      ? newHealerAvailability?.map(
                                          (item, index) => {
                                            return (
                                              <>
                                                <OverlayTrigger
                                                  delay={{
                                                    hide: 450,
                                                    show: 300,
                                                  }}
                                                  overlay={(props) => (
                                                    <Tooltip {...props}>
                                                      {item.timing.map(
                                                        (item, index) =>
                                                          item
                                                            ? "\xa0\xa0" +
                                                              ` ${item} ` +
                                                              "\xa0\xa0"
                                                            : "Closed"
                                                      )}
                                                      {/* {item?.opens_at &&
                                                  item?.closes_at
                                                  ? `${tConvert(
                                                    item?.opens_at.slice(
                                                      0,
                                                      5
                                                    )
                                                  )}-${tConvert(
                                                    item?.closes_at.slice(
                                                      0,
                                                      5
                                                    )
                                                  )}`
                                                  : "Closed"} */}
                                                    </Tooltip>
                                                  )}
                                                  placement="top"
                                                >
                                                  <button
                                                    key={index}
                                                    type="button"
                                                    style={{
                                                      color:
                                                        item?.is_closed == 1
                                                          ? "red"
                                                          : "",
                                                    }}
                                                  >
                                                    {item?.day?.slice(0, 2)}
                                                  </button>
                                                </OverlayTrigger>
                                              </>
                                            );
                                          }
                                        )
                                      : "Not Specified"}
                                  </div>
                                </li>
                                <li>
                                  <i className="ri-calendar-line"></i>{" "}
                                  <span className={styles["available"]}>
                                    {data?.todayAvailability?.is_closed == 0
                                      ? "Available Today"
                                      : "Closed Today"}
                                  </span>
                                </li>
                              </ul>
                              <div className={styles["contact-healer"]}>
                                <ul>
                                  {data?.healer?.booking_types?.map((item, i) =>
                                    item?.booking_type?.name === "Both" ? (
                                      <>
                                        <li>
                                          <Link
                                            href="#"
                                            onClick={(e) => e.preventDefault()}
                                          >
                                            <i className="ri-user-line"></i>
                                          </Link>
                                        </li>
                                        <li>
                                          <Link
                                            href="#"
                                            onClick={(e) => e.preventDefault()}
                                          >
                                            <i className="ri-phone-line"></i>
                                          </Link>
                                        </li>
                                        <li>
                                          <Link
                                            href="#"
                                            onClick={(e) => e.preventDefault()}
                                          >
                                            <i className="ri-vidicon-line"></i>
                                          </Link>
                                        </li>
                                      </>
                                    ) : item?.booking_type?.name ===
                                      "In-person" ? (
                                      <li>
                                        <Link
                                          href="#"
                                          onClick={(e) => e.preventDefault()}
                                        >
                                          <i className="ri-user-line"></i>
                                        </Link>
                                      </li>
                                    ) : (
                                      <>
                                        <li>
                                          <Link
                                            href="#"
                                            onClick={(e) => e.preventDefault()}
                                          >
                                            <i className="ri-phone-line"></i>
                                          </Link>
                                        </li>
                                        <li>
                                          <Link
                                            href="#"
                                            onClick={(e) => e.preventDefault()}
                                          >
                                            <i className="ri-vidicon-line"></i>
                                          </Link>
                                        </li>
                                      </>
                                    )
                                  )}
                                </ul>
                                <Link
                                  href={`/healers/${data?.healer?.slug}/slots`}
                                  className={styles["theme-btn"]}
                                >
                                  Book a Session
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                    {data?.healer?.healer_image?.length != 0 ? (
                      <Col md={12} className="pb-5">
                        <div
                          className={
                            styles["about-healerdetails-test"] +
                            " " +
                            styles["multiple-images-section"]
                          }
                        >
                          <h3>Our Gallery </h3>
                          <Col md={12}>
                            <OwlCarousel
                              className={
                                styles["healer-review-slider"] +
                                " " +
                                "owl-theme"
                              }
                              loop={false}
                              margin={10}
                              nav={false}
                              dots={true}
                              autoplay={true}
                              responsive={{
                                0: {
                                  items: 1,
                                },
                                300: {
                                  items: 2,
                                },
                                600: {
                                  items: 3,
                                },
                                900: {
                                  items: 4,
                                },
                                1200: {
                                  items: 5,
                                },
                              }}
                            >
                              {data?.healer?.healer_image?.map(
                                (item, index) => {
                                  return (
                                    <div className="item" key={index}>
                                      <Image
                                        src={item.path}
                                        width={246}
                                        height={250}
                                        alt="multiple-images"
                                        style={{ objectFit: "fill" }}
                                        onClick={() => {
                                          setImageShow(true);
                                          setImageId(item?.id);
                                        }}
                                      ></Image>
                                    </div>
                                  );
                                }
                              )}
                            </OwlCarousel>
                          </Col>
                        </div>
                      </Col>
                    ) : (
                      ""
                    )}
                    <Col md={12} className="pb-5">
                      <div className={styles["about-healerdetails-test"]}>
                        <h3>
                          About{" "}
                          {data?.healer?.first_name +
                            " " +
                            data?.healer?.last_name ?? "Not Specified"}{" "}
                          :
                        </h3>
                        {data?.healer?.detail?.professional_summary ? (
                          <div
                            className={styles["healer-profile-summary"]}
                            dangerouslySetInnerHTML={{
                              __html:
                                data?.healer?.detail?.professional_summary,
                            }}
                          />
                        ) : (
                          <p>Not Available</p>
                        )}
                        {data?.healer?.modalities?.length != 0 ? (
                          <>
                            <h4>Specializations:</h4>
                            <ul className={styles["specializations-test"]}>
                              {data?.healer?.modalities?.map((item, index) => {
                                return (
                                  <li key={index}>
                                    {item?.modality?.name
                                      ? item?.modality?.name
                                      : "Not Specified"}
                                  </li>
                                );
                              })}
                            </ul>
                          </>
                        ) : (
                          ""
                        )}
                        {data?.healer?.symptoms?.length != 0 ? (
                          <>
                            <h4>Expertise In:</h4>
                            <ul className={styles["specializations-test"]}>
                              {data?.healer?.symptoms?.map((item, index) => {
                                return (
                                  <li key={index}>
                                    {item?.symptom?.name
                                      ? item?.symptom?.name
                                      : "Not Specified"}
                                  </li>
                                );
                              })}
                            </ul>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>
                  </Row>
                </Container>
              </section>
              <section className={styles["healer-review-section"]}>
                <Container className={styles["container"]}>
                  <Row>
                    <Col md={12}>
                      <div className={styles["header-review"]}>
                        <div className={styles["title"]}>
                          {data?.healer?.first_name +
                            " " +
                            data?.healer?.last_name ?? "Not Specified"}{" "}
                          - Reviews
                        </div>
                        <Button
                          className={
                            styles["theme-btn"] +
                            " " +
                            "offcanvas-btn d-none d-md-block"
                          }
                          onClick={() => viewAllReview()}
                        >
                          View All Reviews
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Row className={styles["middle-section"]}>
                    <Col md={4} sm={6} className="col-6">
                      <div
                        className={
                          styles["rating-card"] + " " + "border-0" + " " + "p-0"
                        }
                      >
                        <h4>Total Reviews</h4>
                        <h3>{data?.healer?.review?.length ?? 0}</h3>
                        <p>Over all reviews</p>
                      </div>
                    </Col>
                    <Col md={4} sm={6} className="col-6">
                      <div className={styles["rating-card"]}>
                        <h4>Average Rating</h4>
                        <div className={styles["average-rating"]}>
                          <h3>{data?.rating ?? 0}</h3>
                          <span>
                            {[...Array(5).keys()].map((i, j) => (
                              <>
                                <i
                                  key={j}
                                  className={`ri-star-fill ${
                                    i + 1 <= data?.rating ? "star-fill" : ""
                                  }`}
                                ></i>
                              </>
                            ))}
                          </span>
                        </div>
                        <p>Average rating on this year</p>
                      </div>
                    </Col>
                    <Col md={4} className="d-none d-md-block">
                      <div
                        className={
                          styles["rating-card"] +
                          " " +
                          styles["ratingcard-progress"]
                        }
                      >
                        <ul className={styles["rating-progressbar"]}>
                          {[...Array(5).keys()].reverse().map((i, j) => (
                            <>
                              <li key={j}>
                                <span className={styles["rating-no"]}>
                                  <i className="ri-star-fill"></i>
                                  {i + 1}
                                </span>
                                <span
                                  className={styles["progress-line"]}
                                ></span>
                                <span className={styles["total-review"]}>
                                  {data?.reviewRatings?.find(
                                    (k) => k.rating == i + 1
                                  )?.count ?? 0}
                                </span>
                              </li>
                            </>
                          ))}
                        </ul>
                      </div>
                    </Col>
                  </Row>
                  <Col md={12}>
                    <OwlCarousel
                      className={
                        styles["healer-review-slider"] + " " + "owl-theme"
                      }
                      loop={false}
                      margin={10}
                      nav={false}
                      dots={true}
                      responsive={{
                        0: {
                          items: 1,
                        },
                        600: {
                          items: 2,
                        },
                        1000: {
                          items: 3,
                        },
                      }}
                    >
                      {data?.healer?.review?.map((item, index) => {
                        return (
                          <div className="item" key={item?.id}>
                            <div className={styles["review-card"]}>
                              <h5>{item?.title ?? "N/A"}</h5>
                              {/* <p>
                            {showReviewMore
                              ? item?.review
                              : `${item?.review.substring(0, 100)}`}
                          </p> */}
                              <p>
                                {reviewsIndex == item.id
                                  ? item?.review
                                  : `${item?.review?.substring(0, 100)}`}
                              </p>
                              {item?.review?.length > 100 ? (
                                reviewsIndex != item.id ? (
                                  <Button
                                    className={
                                      styles["theme-btn"] +
                                      " " +
                                      "theme-btn" +
                                      " " +
                                      "offcanvas-btn"
                                    }
                                    id={item.id}
                                    type="button"
                                    // onClick={() => {
                                    //   setShowArrayMore(
                                    //     [...showArrayMore].map((object) => {
                                    //       if (object.index == index) {
                                    //         return {
                                    //           ...object,
                                    //           value: true,
                                    //         };
                                    //       } else return object;
                                    //     })
                                    //   );
                                    // }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setReviewIndex(item.id);
                                    }}
                                  >
                                    Show More
                                  </Button>
                                ) : (
                                  <Button
                                    className={
                                      styles["theme-btn"] +
                                      " " +
                                      "theme-btn" +
                                      " " +
                                      "offcanvas-btn"
                                    }
                                    id={item.id}
                                    // onClick={() => {
                                    //   setShowArrayMore(
                                    //     [...showArrayMore].map((object) => {
                                    //       if (object.index == index) {
                                    //         return {
                                    //           ...object,
                                    //           value: false,
                                    //         };
                                    //       } else return object;
                                    //     })
                                    //   );
                                    // }}
                                    onClick={() => setReviewIndex()}
                                  >
                                    Show Less
                                  </Button>
                                )
                              ) : (
                                ""
                              )}
                              {/* <Button className={styles["theme-btn"] + ' ' + "offcanvas-btn"} >
                            {showReviewMore ? 'Show Less' : 'Show More'} <i className="ri-arrow-right-s-line"></i>
                          </Button> */}
                              <span>
                                {[...Array(5).keys()].map((i, j) => (
                                  <>
                                    <i
                                      key={`j-${j}`}
                                      className={`ri-star-fill ${
                                        i + 1 <= item?.rating ? "star-fill" : ""
                                      }`}
                                    ></i>
                                  </>
                                ))}
                              </span>
                              <div className={styles["author-details"]}>
                                <h5>
                                  {item?.customer?.first_name +
                                    " " +
                                    item?.customer?.last_name ?? "N/A"}
                                </h5>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </OwlCarousel>
                  </Col>
                  <Col md={12} className="text-center mt-3">
                    <Button
                      className={
                        styles["theme-btn"] + " " + "offcanvas-btn w-auto"
                      }
                      onClick={() => viewAllReview()}
                    >
                      View All Reviews
                    </Button>
                  </Col>
                </Container>
              </section>
              <hr />
              {healerCourses.length != 0 ? (
                <section className="ourcourses-section">
                  <Container>
                    <div className="row courses-head-img">
                      <Col md={2}>
                        <Image
                          width={130}
                          height={76}
                          src="/images/hand-left.svg"
                          alt=""
                        />
                      </Col>
                      <Col md={8}>
                        <div className="section-title">
                          <h3 className="title">Courses</h3>
                          <p>
                            Our verified healers are providing various courses
                            in all different modalities which anyone can learn
                            and get certified to help connect with your inner
                            self and practice self care.
                          </p>
                        </div>
                      </Col>
                      <Col md={2}>
                        <Image
                          width={130}
                          height={81}
                          src="/images/hand-right.svg"
                          alt=""
                        />
                      </Col>
                    </div>
                    <Col md={12}>
                      {healerCourses != 0 ? (
                        <OwlCarousel
                          className="courses-slider owl-theme"
                          loop={false}
                          margin={15}
                          nav={false}
                          dots={true}
                          responsive={{
                            0: {
                              items: 1,
                            },
                            600: {
                              items: 3,
                            },
                            1000: {
                              items: 4,
                            },
                          }}
                        >
                          {healerCourses?.map((item, index) => {
                            return (
                              <Col className="mb-3" key={index}>
                                <div className="courses-card">
                                  <div className="courses-content">
                                    <h3>
                                      {(item?.class?.name?.length > 25
                                        ? item?.class?.name?.slice(0, 85) +
                                          "....."
                                        : item?.class?.name) ?? "Not Specified"}
                                    </h3>
                                    <h4>
                                      {(item?.class?.short_description?.length >
                                      25
                                        ? item?.class?.short_description?.slice(
                                            0,
                                            100
                                          )
                                        : item?.class?.short_description) ??
                                        "Not Specified"}
                                    </h4>
                                    <ul>
                                      <li>
                                        <i className="ri-time-line"></i>{" "}
                                        <span>
                                          {item?.class?.duration
                                            ? item?.class?.duration + " Days"
                                            : "Not Specified"}
                                        </span>
                                      </li>
                                      <li>
                                        <i className="ri-user-3-line"></i>{" "}
                                        <span>
                                          {item?.booking_type?.name ??
                                            "Not Specified"}
                                        </span>
                                      </li>
                                    </ul>
                                    <Link
                                      href={`/courses/${item.slug}/detail`}
                                      //onClick={() => setDetailData({})}
                                      className="theme-btn"
                                    >
                                      Book Class{" "}
                                      <i className="ri-arrow-right-line"></i>
                                    </Link>
                                  </div>
                                </div>
                              </Col>
                            );
                          })}
                        </OwlCarousel>
                      ) : (
                        <p>Not Available</p>
                      )}
                    </Col>
                    <Col md={12} className="mt-3 text-center">
                      <Link href={"/courses"} className="theme-btn">
                        Explore More Courses{" "}
                        <i className="ri-arrow-right-line"></i>
                      </Link>
                    </Col>
                  </Container>
                </section>
              ) : (
                ""
              )}
              <section className="healartab-section">
                <Container>
                  <Row>
                    <Col md={12}>
                      <nav className="nav-healer">
                        <div
                          className="nav nav-tabs"
                          id="nav-tab"
                          role="tablist"
                        >
                          {/* <Button
                            className={`nav-link ${
                              activeTab == "education" ? "show active" : ""
                            }`}
                            onClick={() => setActiveTab("education")}
                            id="education-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#education"
                            type="button"
                            role="tab"
                            aria-controls="education"
                            aria-selected="true"
                          >
                            <i className="ri-hotel-line"></i>
                            Education
                          </Button> */}
                          <Button
                            className={`nav-link ${
                              activeTab == "experience" ? "show active" : ""
                            }`}
                            onClick={() => setActiveTab("experience")}
                            id="work-experience-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#work-experience"
                            type="button"
                            role="tab"
                            aria-controls="work-experience"
                            aria-selected="false"
                          >
                            <i className="ri-briefcase-2-line"></i>
                            Experience
                          </Button>
                          <Button
                            className={`nav-link ${
                              activeTab == "awards" ? "show active" : ""
                            }`}
                            onClick={() => setActiveTab("awards")}
                            id="awards-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#awards"
                            type="button"
                            role="tab"
                            aria-controls="awards"
                            aria-selected="false"
                          >
                            <i className="ri-award-line"></i>
                            Awards
                          </Button>
                          <Button
                            className={`nav-link ${
                              activeTab == "certifications" ? "show active" : ""
                            }`}
                            onClick={() => setActiveTab("certifications")}
                            id="certifications-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#certifications"
                            type="button"
                            role="tab"
                            aria-controls="certifications"
                            aria-selected="false"
                          >
                            <i className="ri-award-line"></i>
                            Certifications
                          </Button>
                          {/* <Button
                        className={`nav-link ${activeTab == "articles" ? "show active" : ""
                          }`}
                        onClick={() => setActiveTab("articles")}
                        id="articles-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#articles"
                        type="button"
                        role="tab"
                        aria-controls="articles"
                        aria-selected="false"
                      >
                        <i className="ri-file-text-line"></i>
                        Articles
                      </Button> */}
                        </div>
                      </nav>
                      <div
                        className="tab-content healertab-content"
                        id="nav-tabContent"
                      >
                        {/* <div
                          className={`tab-pane fade ${
                            activeTab == "education" ? "show active" : ""
                          }`}
                          id="education"
                        >
                          <h4 className="content-text">Education :</h4>
                          <Table className="table">
                            <thead>
                              <tr>
                                <th>S/n</th>
                                <th>Degree</th>
                                <th>Degree Name</th>
                                <th>University Name</th>
                                <th>Year</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data?.healer?.education.length ? (
                                data?.healer?.education?.map((item, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>
                                        {item?.education_type?.name ?? "N/A"}
                                      </td>
                                      <td>{item?.course_name ?? "N/A"}</td>
                                      <td>{item?.university_name ?? "N/A"}</td>
                                      <td>{item?.end_to ?? "N/A"}</td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td className="text-center" colSpan={5}>
                                    No records!
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div> */}
                        <div
                          className={`tab-pane fade ${
                            activeTab == "experience" ? "show active" : ""
                          }`}
                          id="experience"
                        >
                          <h4 className="content-text">Experience :</h4>
                          <Table className="table">
                            <thead>
                              <tr>
                                <th>S/n</th>
                                <th>Certification Title</th>
                                <th>Organization</th>
                                <th>Year</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data?.healer?.experience.length ? (
                                data?.healer?.experience?.map((item, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{item?.title_name ?? "N/A"}</td>
                                      <td>
                                        {item?.organization_name ?? "N/A"}
                                      </td>
                                      <td>{item?.start_date ?? "N/A"}</td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td className="text-center" colSpan={4}>
                                    No records!
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                        <div
                          className={`tab-pane fade ${
                            activeTab == "awards" ? "show active" : ""
                          }`}
                          id="awards"
                        >
                          <h4 className="content-text">Awards :</h4>
                          <Table className="table">
                            <thead>
                              <tr>
                                <th>S/n</th>
                                <th>Award Name</th>
                                <th className="text-center">View</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data?.healer?.award_certification.length ? (
                                data?.healer?.award_certification?.map(
                                  (award, index) => {
                                    if (award?.type == "Award") {
                                      return (
                                        <tr key={index}>
                                          <td>{(sno += 1)}</td>
                                          <td>{award?.name ?? "N/A"}</td>
                                          <td className="text-center">
                                            <Link
                                              type="button"
                                              href={award.file}
                                              target="_blank"
                                            >
                                              <i className="fa fa-eye"></i>
                                            </Link>
                                          </td>
                                        </tr>
                                      );
                                    }
                                  }
                                )
                              ) : (
                                <tr>
                                  <td className="text-center" colSpan={3}>
                                    No records!
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                        <div
                          className={`tab-pane fade ${
                            activeTab == "certifications" ? "show active" : ""
                          }`}
                          id="certifications"
                        >
                          <h4 className="content-text">Certifications :</h4>
                          <Table className="table">
                            <thead>
                              <tr>
                                <th>S/n</th>
                                <th>Modality</th>
                                <th>Certification Name</th>
                                <th>Organization</th>
                                <th>Year</th>
                                <th className="text-center">View</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data?.healer?.award_certification.length ? (
                                data?.healer?.award_certification?.map(
                                  (certification, index) => {
                                    if (certification.type == "Certification") {
                                      return (
                                        <tr key={index}>
                                          <td>{(snum += 1)}</td>
                                          <td>
                                            {certification?.modality?.name ??
                                              "N/A"}
                                          </td>
                                          <td>
                                            {certification?.name ?? "N/A"}
                                          </td>
                                          <td>
                                            {certification?.affiliated_organization ??
                                              "N/A"}
                                          </td>
                                          <td>
                                            {certification?.year ?? "N/A"}
                                          </td>
                                          <td className="text-center">
                                            <Link
                                              type="button"
                                              href={certification.file}
                                              target="_blank"
                                            >
                                              <i className="fa fa-eye"></i>
                                            </Link>
                                          </td>
                                        </tr>
                                      );
                                    }
                                  }
                                )
                              ) : (
                                <tr>
                                  <td className="text-center" colSpan={6}>
                                    No records!
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                        {/* <div
                      className={`tab-pane fade ${activeTab == "articles" ? "show active" : ""
                        }`}
                      id="articles"
                    >
                      <h4 className="content-text">Articles :</h4>
                      <Table className="table">
                        <thead>
                          <tr>
                            <th>S/n</th>
                            <th>Title Name</th>
                            <th>Year</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>
                              (AIMU) American International Medical University
                            </td>
                            <td>2010 - 2012</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>American Dental Medical University</td>
                            <td>2008 - 2010</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>New Apollo Hospital, California</td>
                            <td>2006 - 2008</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>New Apollo Hospital, California</td>
                            <td>2006 - 2008</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div> */}
                      </div>
                    </Col>
                  </Row>
                </Container>
              </section>
              {sliderInfo?.data?.length ? (
                <section className={styles["blog-section"]}>
                  <Container>
                    <Row>
                      <Col md={9} className="m-auto">
                        <div className=" m-auto">
                          <div className="section-title">
                            <h3 className="title">
                              Latest & Most Popular Tips & Tricks For You
                            </h3>
                            <p>
                              Enhance Your Practice with Expert Advice. Discover
                              New Techniques, Insights, and Best Practices for
                              Reiki. Stay Updated with Latest Tips & Tricks for
                              Optimal Healing Results.
                            </p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <>
                          {sliderInfo?.data?.length ? (
                            <OwlCarousel
                              className={styles["blog-slider owl-theme"]}
                              loop={false}
                              margin={10}
                              nav={false}
                              dots={true}
                              responsive={{
                                0: {
                                  items: 1,
                                },
                                600: {
                                  items: 3,
                                },
                                1000: {
                                  items: 4,
                                },
                              }}
                            >
                              {sliderInfo?.data?.map((item) => {
                                return (
                                  <>
                                    <div
                                      className={styles["item"]}
                                      key={item.id}
                                    >
                                      <div className={styles["card-blog"]}>
                                        <div className={styles["blog-image"]}>
                                          <Image
                                            height={400}
                                            width={298}
                                            src={
                                              item?.og_image == null
                                                ? "/images/blog-1.jpg"
                                                : item?.og_image
                                            }
                                            alt="blog"
                                          />
                                        </div>
                                        <div className={styles["blog-content"]}>
                                          <div className={styles["blog-date"]}>
                                            {formatDate(item.created_at)}
                                          </div>
                                          <h4>
                                            {item?.title
                                              ? item?.title?.length > 25
                                                ? `${item?.title?.slice(
                                                    0,
                                                    60
                                                  )}.....`
                                                : item?.title
                                              : "Not Specified"}
                                          </h4>
                                          <Link
                                            href={`/blogs/${item?.slug}`}
                                            className={styles["theme-btn"]}
                                          >
                                            Read More
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                );
                              })}
                            </OwlCarousel>
                          ) : (
                            ""
                          )}
                        </>
                      </Col>
                    </Row>
                  </Container>
                </section>
              ) : (
                ""
              )}
            </>
          ) : (
            <Spinner animation="border" size="lg" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          )}
          <section className="healer-review-section">
            <Container>
              <Row>
                <div
                  className={
                    isActive ? "review-offcanvas mysidebar" : "review-offcanvas"
                  }
                >
                  <div className="outer-box">
                    <button
                      type="button"
                      className="close-offcanvas"
                      onClick={() => removeAllReview()}
                    >
                      <i className="ri-close-line"></i>
                    </button>
                    <div className="scrollableDiv" id="scrollableDiv">
                      <InfiniteScroll
                        dataLength={reviewData.length}
                        next={() => fetchHealerAllReviews(true)}
                        hasMore={hasMore}
                        scrollableTarget="scrollableDiv"
                        loader={
                          showMore == false ? (
                            <div className="text-center mt-5">
                              <Spinner animation="border" role="status">
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </Spinner>
                            </div>
                          ) : (
                            ""
                          )
                        }
                        // endMessage={
                        //   <div className="text-center mt-5">
                        //     <span className="text-center">
                        //       All the healers are listed!
                        //     </span>
                        //   </div>
                        // }
                        style={{ overflow: "hidden" }}
                      >
                        <div className="inner-box">
                          {reviewData?.map((item, index) => {
                            return (
                              <div className="review-card" key={index}>
                                <h4>
                                  {item?.customer?.first_name &&
                                  item?.customer?.last_name
                                    ? `${item?.customer?.first_name} ${item?.customer?.last_name}`
                                    : "Not Specified"}
                                </h4>
                                <div className="rating">
                                  <span>
                                    {[...Array(5).keys()].map((i, j) => (
                                      <>
                                        <i
                                          key={j}
                                          className={`ri-star-fill ${
                                            i + 1 <= item?.rating
                                              ? "star-fill"
                                              : ""
                                          }`}
                                        ></i>
                                      </>
                                    ))}
                                  </span>
                                  <h6>
                                    {formatDate(item?.created_at) ??
                                      "Date Not Available"}
                                  </h6>
                                </div>
                                <div className="Specialist">
                                  <h4>{item?.title ?? "Not Specified"}</h4>
                                </div>
                                <p>
                                  {reviewsIndexNumber == item.id
                                    ? item?.review
                                    : `${item?.review?.substring(0, 100)}`}
                                </p>
                                {item?.review?.length > 100 ? (
                                  reviewsIndexNumber != item.id ? (
                                    <Button
                                      className={"theme-btn offcanvas-btn"}
                                      id={item.id}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setReviewIndexNumber(item.id);
                                      }}

                                      // onClick={() => {
                                      //   setShowArrMore(
                                      //     [...showArrMore].map((object) => {
                                      //       if (object.index == index) {
                                      //         return {
                                      //           ...object,
                                      //           value: true,
                                      //         };
                                      //       } else return object;
                                      //     })
                                      //   );
                                      // }}
                                    >
                                      Show More
                                    </Button>
                                  ) : (
                                    <Button
                                      className={"theme-btn offcanvas-btn"}
                                      id={item.id}
                                      // onClick={() => {
                                      //   setShowArrMore(
                                      //     [...showArrMore].map((object) => {
                                      //       if (object.index == index) {
                                      //         return {
                                      //           ...object,
                                      //           value: false,
                                      //         };
                                      //       } else return object;
                                      //     })
                                      //   );
                                      // }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setReviewIndexNumber();
                                      }}
                                    >
                                      Show Less
                                    </Button>
                                  )
                                ) : (
                                  ""
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </InfiniteScroll>
                    </div>
                  </div>
                </div>
              </Row>
            </Container>
          </section>
          <Modal
            animation
            className="bookingdietails-modal multipal-popup d-flex align-items-center"
            id="booking-veiwdetails"
            show={imageShow}
            onHide={() => setImageShow(false)}
            centered
          >
            <Modal.Header>
              <button
                type="button"
                className="theme-btn"
                onClick={() => {
                  setImageShow(false);
                }}
              >
                <i className="ri-close-line"></i>
              </button>
            </Modal.Header>
            <Modal.Body>
              <div className="h-100">
                <div>
                  <Image
                    src={
                      previewImage?.length != 0 && !isDataFetched
                        ? previewImage[0].path
                        : "/images/dummy-user.svg"
                    }
                    alt="upload"
                    width={450}
                    height={500}
                  />
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
    </>
  );
};

HealerDetails.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};

export default HealerDetails;

// ssr
export async function getServerSideProps(context) {
  const { params } = context;
  const query_id = params.slug.split("-");
  const query_length = query_id.length - 1;

  const fetchHealerDetail = async () => {
    try {
      const res = await healerServices.getHealerDetails({
        slug: params.slug,
        timezone: moment.tz.guess(true),
      });
      console.log(res, "gdaksagdskhdgkashdasjkghd");
      if (res.status) {
        return res;
      }
    } catch (error) {
      console.error("Error fetching slider data:", error);
    }
  };
  const fetchHealerDetailMeta = async () => {
    try {
      const res = await healerServices.getMetaInformation("healer-detail");
      if (res.status) {
        return res.data;
      }
    } catch (error) {
      console.error("Error fetching slider data:", error);
    }
  };

  const healerDetailMeta = (await fetchHealerDetailMeta()) ?? {};
  const healerDetailData = (await fetchHealerDetail()) ?? {};

  // Pass data to the page via props
  return { props: { healerDetailMeta, healerDetailData } };
}
